import { CONNECTION_STATUS } from "../../checkAddress/constants";
import { STEPS_BY_RESPONSE_STATUS } from "./constants";
export var buildCompleteAddressString = function buildCompleteAddressString(_ref) {
  var street_with_type = _ref.street_with_type,
    house_type = _ref.house_type,
    house = _ref.house,
    block_type = _ref.block_type,
    block = _ref.block,
    flat_type = _ref.flat_type,
    flat = _ref.flat;
  return [street_with_type && "".concat(street_with_type), house && "".concat(house_type || '', " ").concat(house), block && "".concat(block_type || '', " ").concat(block), flat && "".concat(flat_type || '', " ").concat(flat)].filter(Boolean).join(', ');
};
export var mapCheckConnectionResponse = function mapCheckConnectionResponse(_ref2) {
  var status = _ref2.status,
    isHighSpeed = _ref2.isHighSpeed;
  if (status === CONNECTION_STATUS.IsAvailable && isHighSpeed) {
    return CONNECTION_STATUS.IsHighSpeedAvailable;
  }
  return status;
};
export var mapResponseStatusOnStep = function mapResponseStatusOnStep(status) {
  return STEPS_BY_RESPONSE_STATUS[status];
};